import React from "react";
import { useSelector } from "react-redux";
import { Box, Button, Typography } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";

import ArrowDownSVG from "../Icons/ArrowDownSVG";
import { storeType } from "../redux/store";
import { Devices, useViewport } from "../Hooks/useViewport.hook";

import TransportAlert from "../VehicleCard/TransportAlert";

import sundryMessagesMultipleDeliveries from "../Utilities/sundryMessagesMultipleDeliveries";

const ExpandButton = styled(Button)`
  border: 1px solid;
  border-radius: 8px;
  ${css({
    borderColor: "msg-light-blue",
  })}
`;

const MultipleDeliveryHeader = ({ isExpanded, handleSlideout }) => {
  const viewport = useViewport();

  const store = useSelector((state: storeType) => ({
    selectedForDelivery: state.bookDelivery.selectedForDelivery,
  }));

  const numberOfSundries = store.selectedForDelivery.filter(
    (vehicle) => vehicle.delivery?.isSundry === true
  ).length;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      marginBottom={{ desktop: isExpanded ? 5 : 0, mobile: 5 }}
      marginLeft={42}
      alignItems="center"
    >
      <Box
        as="section"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
      >
        <Typography
          margin={0}
          variant="h5"
          lineHeight="24px"
          color="primary-navy-blue"
        >
          {store.selectedForDelivery.length} Vehicle
          {store.selectedForDelivery.length > 1 && "s"} Selected
        </Typography>

        {numberOfSundries > 0 && (
          <TransportAlert
            message={sundryMessagesMultipleDeliveries({
              totalVehicles: store.selectedForDelivery.length,
              numberOfSundries,
            })}
            mt={2}
          />
        )}
      </Box>

      {(isExpanded || viewport === Devices.MOBILE) && (
        <ExpandButton
          variant="secondary-white"
          padding={0}
          width="44px"
          height="44px"
          onClick={handleSlideout}
        >
          <ArrowDownSVG
            height="24px"
            style={{
              transform: `rotate(${isExpanded ? "0deg" : "-180deg"})`,
              transition: "all 0.2s ease-in-out",
            }}
          />
        </ExpandButton>
      )}
    </Box>
  );
};

export default MultipleDeliveryHeader;
